var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import throttle from 'lodash/throttle';
import * as React from 'react';
import Button from '../button';
import Icon from '../icon';
import Label from '../label';
import LabelGroup from '../label/group';
import Popover from '../popover';
import { Styled, Tags } from './style';
var TagList = /** @class */ (function (_super) {
    __extends(TagList, _super);
    function TagList(props) {
        var _this = _super.call(this, props) || this;
        _this.updateDimensions = function () {
            _this.setState({ height: window.innerHeight, width: window.innerWidth });
        };
        _this.state = {
            width: window.innerWidth,
            height: window.innerHeight,
        };
        _this.handleClickThrottled = throttle(_this.updateDimensions, 500);
        return _this;
    }
    TagList.prototype.componentDidMount = function () {
        this.updateDimensions();
        window.addEventListener('resize', this.handleClickThrottled);
    };
    TagList.prototype.componentWillUnmount = function () {
        window.removeEventListener('resize', this.handleClickThrottled);
        this.handleClickThrottled.cancel();
    };
    TagList.prototype.render = function () {
        var taglist = this.props.taglist;
        var width = this.state.width;
        var tagNumberToDisplayPopover = width > 1919 ? 5 : 3;
        if (taglist !== null && taglist.length) {
            return (React.createElement(Styled, null,
                React.createElement(LabelGroup, { className: "default-list" }, taglist.filter(function (idx) { return taglist.indexOf(idx) < 3; }).map(function (tag) { return (React.createElement(Label, { className: "preview-tag", key: tag, title: tag }, tag)); })),
                React.createElement(LabelGroup, { className: "longer-list" }, taglist.filter(function (idx) { return taglist.indexOf(idx) < 5; }).map(function (tag) { return (React.createElement(Label, { className: "preview-tag", key: tag, title: tag }, tag)); })),
                taglist.length > tagNumberToDisplayPopover &&
                    React.createElement(Popover, { position: "top center", className: "tags-popup", content: React.createElement(Tags, null, taglist.map(function (tag) { return React.createElement(Label, { key: tag, title: tag }, tag); })), trigger: React.createElement("div", { className: "trigger" },
                            React.createElement(Icon, { name: "dot" })) }),
                React.createElement(Popover, { position: "top center", className: "tags-popup", content: React.createElement(Tags, null, taglist.map(function (tag) { return React.createElement(Label, { key: tag, title: tag }, tag); })), trigger: React.createElement(Button, { icon: true, className: "show-tag-btn" },
                        React.createElement(Icon, { name: "tag" })) })));
        }
        else {
            return null;
        }
    };
    return TagList;
}(React.PureComponent));
export default TagList;
//# sourceMappingURL=index.js.map